import React, { Component } from 'react';
import lstModules from 'common/json/lstModules.json';
import $ from 'jquery';

var httpURL = '';
var queryString = require('querystring');

export default class Section extends Component {
    state = {
        key: this.props.sectionKey,
        tabClicked: 0,
        tokenid: localStorage.getItem('tokenid')
    }
    componentDidMount = () => {
        // console.log("Section.js called props passed, data", this.props.data, ", selected", this.props.selected );
        // console.log('data in section = ' + JSON.stringify(this.props.data));
        $('.nav-tabs > .active').find('a').trigger('click');
        var clsSectionId = $('.nav-tabs > .active').find('a').attr('id');

        this.setState(tabClicked => ({
            tabClicked: clsSectionId
        }));
        this.props.parentCallback(clsSectionId);
        // console.log("parentCallBack (handlecallback called from componentDidMount in section.js");
    }




    handleTabClick = (e, classSectionId) => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        // console.log("handleTabClick classSectionId = " + classSectionId);
        $(".nav-item").removeClass('active');
        $(e.target).closest(".nav-item").addClass('active');
        this.setState(tabClicked => ({
            tabClicked: classSectionId
        }));
        this.props.parentCallback(classSectionId);
        // console.log("parentCallBack (handlecallback called from handleTabClick in section.js");
    }

    render() {
        httpURL = lstModules['timeTable'].url + ":" + lstModules['timeTable'].port;

        return (
            <div >
                <div className="container-fluid">
                    <ul className="nav nav-tabs nav-pills nav-fill" role="tablist">
                        {this.props.data.map((item, idx) => {
                            return idx == 0 ?
                                <li className="nav-item active" key={item.sectionId} role="presentation">
                                    <a id={item.sectionId}
                                        data-mdb-toggle="pill"
                                        /* href="#ex1-pills-1"  */
                                        className="nav-link active"
                                        aria-current="page"
                                        href="#"
                                        key={"a_" + item.sectionId}
                                        role="tab"
                                        aria-controls="ex1-pills-1"
                                        aria-selected="true"
                                        onClick={((e) => this.handleTabClick(e, item.sectionId))}
                                    >
                                        {item.section}
                                    </a>
                                </li>
                                :
                                <li className="nav-item" key={item.sectionId} role="presentation">
                                    <a id={item.sectionId}
                                        data-mdb-toggle="pill"
                                        /* href="#ex1-pills-1"  */
                                        className="nav-link"
                                        aria-current="page"
                                        href="#"
                                        key={"a_" + item.sectionId}
                                        role="tab"
                                        aria-controls="ex1-pills-1"
                                        aria-selected="true"
                                        onClick={((e) => this.handleTabClick(e, item.sectionId))}
                                    >
                                        {item.section}
                                    </a>
                                </li>
                        })}
                    </ul>
                </div>
            </div>
        )
    }
};

